import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './i18n_en';
import it from './i18n_it';

Vue.use(VueI18n);

const messages = { en, it };

const i18n = new VueI18n({
    messages
});

export default i18n;
